<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="wrapper">
        <input
          v-bind="attrs"
          v-on="on"
          @blur="date = parseDate(deliveredAt)"
          placeholder="Chọn ngày"
          v-model="deliveredAt"
          class="px-2 delivery input-style"
        />
      </div>
    </template>
    <v-date-picker v-model="date" no-title @input="onChangeDate" color="primary"></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    entity: {
      type: String,
      default: 'deliveredAt'
    }
  },
  data() {
    return {
      menu: false,
      date: null,
      deliveredAt: null
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onChangeDate(date) {
      this.menu = false
      const startOfDay = new Date(
        moment(date)
          .startOf('day')
          .format()
      ).toISOString()
      const endOfDay = new Date(
        moment(date)
          .endOf('day')
          .format()
      ).toISOString()

      this.$emit('changeDate', {
        [`${this.entity}_gte`]: startOfDay,
        [`${this.entity}_lte`]: endOfDay
      })
    }
  },
  watch: {
    date(val) {
      if (val) {
        this.deliveredAt = this.formatDate(this.date)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  border: 1px solid #00000066;
  border-radius: 4px;
  background: white;
  height: 28px;
  overflow: hidden;
  max-width: 150px;
}
.input-style {
  height: 100%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);

  &::placeholder {
    color: #00000066;
  }
}
</style>
